import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BspceRequest } from '../interfaces/bspce-request.interface';
import { BspceResponse } from '../interfaces/bspce-response.interface';

@Injectable({
  providedIn: 'root',
})
export class BspceService {
  private readonly http = inject(HttpClient);

  public postBspceSimulation(request: Partial<BspceRequest>): Observable<BspceResponse> {
    return this.http.post<BspceResponse>('/rgg/fis/v1/bspce-simulation', request);
  }
}
